import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { BillingPlanTier } from '@core/billing-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent, IconComponent, RtTooltip } from '@core/user-interface-legacy';

import { PlanPickerModel } from '../plan-picker.model';

@Component({
  selector: 'rt-plan-picker-compare',
  templateUrl: './plan-picker-compare.component.html',
  styleUrls: ['./plan-picker-compare.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, IconComponent, RtTooltip, TranslatePipe],
})
export class PlanPickerCompareComponent {
  public readonly content = inject(PlanPickerModel);

  @Input() public highlighted: BillingPlanTier;
  @Input() public active: BillingPlanTier | string;

  public BillingPlanTier = BillingPlanTier;

  public trackByIndex(index: number) {
    return index;
  }
}
